import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";


export default class NewMessageState extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "newMessageState";
    }

    public receive(payload: CometOperatorApplication.NewMessageStateCometMessageOpenApiModel): void {
        if (OperatorApplicationConfigInstance.newMessageNotificationsEnabled) {
        OperatorApplicationPlatformFactory.notifications.show({
            groupId: payload.username,
            title: payload.notificationTitle,
            text: payload.notificationText,
            click: async () => {
                await OperatorApplicationBuddyList.addClientAndOpenByUsername(payload.username, payload.messageId);
            }
        });
        }
    }

}